import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled from 'styled-components';

const Audio = styled.audio`
  background: #000;
  width: 100%;
  height: 100%;
`;

const Audioplayer = forwardRef(({ nodeId }, ref) => (
  <Audio
    ref={ref}
    id={nodeId}
    preload="metadata"
    className="video-js audio"
    playsInline
  />
));

Audioplayer.propTypes = {
  nodeId: PropTypes.string.isRequired,
};

export default Audioplayer;
